import { Brand, Category, ProductInfo } from "@/types/AppTypes";

const  combineSingleProduct =(
    product: any,
    productInfos: ProductInfo[],
    brands: Brand[],
    categories: Category[]
  ) =>{
    if (!product) return null;
  
    const brandMap = Object.fromEntries(
      (brands || []).map((b) => (b?.id ? [b.id, b] : [])).filter((entry) => entry.length)
    );
    const categoryMap = Object.fromEntries(
      (categories || []).map((c) => (c?.id ? [c.id, c] : [])).filter((entry) => entry.length)
    );
    const productInfoMap = Object.fromEntries(
      (productInfos || []).map((p) => (p?.id ? [p.id, p] : [])).filter((entry) => entry.length)
    );
  
    const productInfo = productInfoMap[product.product_id];
    const brand = brandMap[productInfo?.brand_id];
    let category;
  
    if (productInfo?.category_id) {
      if (Array.isArray(productInfo.category_id)) {
        category = productInfo.category_id
          .map((catId: string) => categoryMap[catId])
          .filter(Boolean);
      } else {
        const singleCategory = categoryMap[productInfo.category_id];
        category = singleCategory ? [singleCategory] : [];
      }
    } else {
      category = [];
    }
  
    return {
      ...product,
      brand,
      category,
    };
  }

  export default combineSingleProduct;